import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoginService } from '../../services/login.service';
import { StoreNavigationComponent } from '../../shared/components/store-navigation/store-navigation.component';
import { VerifyOtpComponent } from '../../shared/components/verify-otp/verify-otp.component';
import { Globals } from '../../shared/services/global';
import { VerifyMpinComponent } from '../../shared/components/verify-mpin/verify-mpin.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  loginForm: FormGroup = new FormGroup({});
  productList: Array<any> = [
    { img: './images/productImage1.svg', details: 'login.productDetail1' },
    { img: './images/productImage2.svg', details: 'login.productDetail2' },
  ]

  otpForm: FormGroup = new FormGroup({});
  enterOtp: boolean = false;

  translateSubscription: Subscription;
  errorMsgs: any = [];
  userDetails: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private globals: Globals
  ) {
    this.translateSubscription = translate.get(['toasterStatus']).subscribe((data: any) => {
      this.errorMsgs = data
    })
  }

  ngOnInit() {
    localStorage.removeItem('encryptionkey');
    localStorage.removeItem('authToken');
    this.loginForm = this.fb.group(
      {
        icNumber: new FormControl('', [Validators.required, Validators.maxLength(12), Validators.minLength(12)])
      }
    )

    let body = {
      "parentVersion": "",
      "version": "1.0.0",
      "platform": "W"
    }
    this.loginService.getCurrentAppVersion(body).subscribe((res: any) => {
      if (res && res.status && res.status.isSuccess == true && res.content && res.content.key) {
        localStorage.setItem('encryptionkey', res.content.key);
      }
    })
  }

  loginClick() {
    // this.enterOtp = true;
    // this.otpForm = this.fb.group(
    //   {
    //     otp: new FormControl('', [Validators.required])
    //   }
    // )
    this.dialog.open(VerifyMpinComponent, { height: '551px', width: '612px', data: { icNumber: this.loginForm.controls['icNumber'].value } }).afterClosed().subscribe((response: any) => {
      if (response.event == 'mpinVerified') {
        this.userDetails = response.userDetails;
        this.dialog.open(VerifyOtpComponent, { height: '551px', width: '612px', data: response.userDetails }).afterClosed().subscribe((res1: any) => {
          if (res1 && res1.length == 4) {
            sessionStorage.setItem('userDetails', btoa(JSON.stringify(this.userDetails)));
            this.router.navigate(['/home/account'])
          }
        })
      } else if (response.event == 'forgot'){
        this.forgetPinClick()
      }
    })
  }

  onOtpChange(otp: any) {
    this.otpForm.controls['otp'].setValue(otp);
  }

  // verifyOtp() {
  //   let body = {
  //     "loginType": 1,
  //     "userName": this.loginForm.controls['icNumber'].value,
  //     "password": this.otpForm.controls['otp'].value,
  //     "cipher": "",
  //     "appLoginPin": "",
  //     "noSharedPreference": true
  //   }
  //   this.loginService.loginUser(body).subscribe((res: any) => {
  //     if (res && res.status && res.status.isSuccess) {
  //       this.userDetails = res.content;
  //       // sessionStorage.setItem('userDetails',)
  //       this.dialog.open(VerifyOtpComponent, { height: '551px', width: '612px', data: res.content }).afterClosed().subscribe((res1: any) => {
  //         if (res1 && res1.length == 4) {
  //           sessionStorage.setItem('userDetails', btoa(JSON.stringify(this.userDetails)));
  //           this.router.navigate(['/home/account'])
  //         }
  //       })
  //     }
  //     else {
  //       this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error)
  //     }
  //   })

  // }

  forgetPinClick() {
    this.globals.allowForgetPinFlow = true;
    this.router.navigate(['/forget-password'])
  }

  otpFormControl() {
    return this.otpForm.controls['otp'].value;
  }

  registerClick() {
    let data = {
      content: 'login.registerContent'
    }
    this.dialog.open(StoreNavigationComponent, { height: '392px', width: '612px', data: data }).afterClosed().subscribe((res: any) => {

    })
  }

  isNumberKey(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && ((charCode < 48 || charCode > 57)))
      return false;
    return true;
  }
}
